export default __webpack_public_path__ + "static/media/maxpet.97a2e8e6.png";